import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
  useCallback,
} from "react";

interface NavigationContextType {
  navOpen: boolean;
  toggleNav: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(
  undefined,
);

const isLargeScreen = () => window.innerWidth >= 1024;

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};

export const NavigationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setNavOpen(isLargeScreen());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleNav = useCallback(() => {
    if (!isLargeScreen()) {
      setNavOpen(prev => !prev);
    }
  }, []);

  return (
    <NavigationContext.Provider value={{ navOpen, toggleNav}}>
      {children}
    </NavigationContext.Provider>
  );
};
